import type { IconButtonProps } from '@workramp/ui';
import { IconButton } from '@workramp/ui';
import { AppState, I18n } from '~/common/explicit-exports';
import { ButtonWrapper } from './BookmarkButton.styles';

export interface BookmarkButtonProps extends Omit<IconButtonProps, 'label' | 'iconName' | 'onPress'> {
  isBookmarked: boolean;
  isLoading?: boolean;
  onAdd: () => void;
  onRemove: () => void;
}

export function BookmarkButton({
  isBookmarked,
  isLoading = false,
  onAdd,
  onRemove,
  variant = 'text',
  color = 'secondary',
  ...props
}: BookmarkButtonProps) {
  const ADD_LABEL = I18n.t('js.learner.saved_content.add_to_saved_content');
  const REMOVE_LABEL = I18n.t('js.learner.saved_content.remove_from_saved_content');

  const handleBookmark = () => (isBookmarked ? onRemove() : onAdd());

  // PAR-950 white label users can't see saved content
  const { isWhiteLabel } = AppState;

  return (
    !isWhiteLabel && (
      <ButtonWrapper $isHidden={isLoading}>
        <IconButton
          label={isBookmarked ? REMOVE_LABEL : ADD_LABEL}
          iconName={isBookmarked ? 'bookmark:solid' : 'bookmark:regular'}
          variant={variant}
          color={color}
          onPress={handleBookmark}
          {...props}
        />
      </ButtonWrapper>
    )
  );
}
